<template>
    <div class = "personal-inf">
        <div class="personal-inf__item">
            <div class="personal-inf__title">Старый пароль</div>
            <div class="inf-field">
                <reg-input :value = "oldPass.value " :pattern = "oldPass.patternInput" @input = 'setData($event)'></reg-input>
            </div>
            <div class="personal-pass-message">{{truePass}}</div>
        </div>
        <div class="personal-inf__item">
            <div class="personal-inf__title">Новый пароль</div>
            <div class="inf-field">
                <reg-input :value = "newPass.value " :pattern = "newPass.patternInput" @input = 'setDataContact($event)'></reg-input>
            </div>
            <div  v-show="showButton" class="save-button" @click='onChange'>
                <loader v-if="loading" :styles="loaderStyle"/>
                <span v-if="!loading">Сохранить</span>
            </div>
            <div v-if="messageSave === 'error'" class="errorMessage">Ошибка сохранения данных!<br>Попробуйте повторить запрос позже!</div>
            <div v-if="messageSave === 'success'" class="successMessage">Данные успешно сохранены!</div>
        </div>
    </div>
</template>
<script>
import { mapGetters } from "vuex";
import Input from "../ui-components/reg-input"
import Loader from "../ui-components/preloader"
export default {
    components : {
        'reg-input':Input,
        'loader':Loader
    },
    data() {
        return {
            oldPass: {
                title:'Имя',
                patternInput: /^[а-яА-Я]{2,30}$/,
                value:''
            },
            newPass: {
                title:'Телефон',
                patternInput: /^[а-яА-Я]{2,30}$/,
                value:''
            },
            infoUser : {},
            check:false,
            loaderStyle: {width:30 + 'px',height:30 + 'px', margin:0 + 'px'},
            loading:false,
            messageSave:null
        }
    },
    computed : {
         ...mapGetters({
            getMessageSaveDetails:'auth/getMessageSaveUserDetail'
        }),
        truePass(){
            let  msg = 'Введите корректный действующий пароль'
            if (this.oldPass.value != '' & this.oldPass.value != this.infoUser.User.Password)
                return msg
        },
        showButton() {
            if(this.oldPass.value == this.infoUser.User.Password & this.newPass.value != '')
            return true;
        }
    },
    methods : {
        setData(data) {
            this.oldPass.value = data.value
        },
        setDataContact(data) {
            this.newPass.value = data.value
        },
        async onChange() {
            this.loading = true;
            this.messageSave = null;
            let payload = {
                    Login:this.infoUser.User.Login,
                    Password:this.newPass.value,
                    currentPassword:this.oldPass.value,
                }
            await this.$store.dispatch('auth/saveUserInfo', payload);
            this.loading = false;
            this.messageSave = this.getMessageSaveDetails;
        }
    },
    created (){
        this.infoUser = this.$store.getters['auth/getInfoUser']
    }

}
</script>
<style lang="less">
.personal-inf {
    display: flex;
    justify-content: space-between;
    margin-top: 50px;
    width: 100%;
    &__item {
        width: 444px;
    }
}
.personal-inf__title {
    font-family: Montserrat;
    font-size: 16px;
    font-weight: 600;
    font-style: normal;
    font-stretch: normal;
    line-height: 3;
    letter-spacing: 0.4px;
    text-align: left;
    color: #ffffff;
}
.inf-field {
    width: 100%;
    margin-bottom: 12px;
    &__name {
        font-family: Arimo;
        font-size: 11px;
        font-weight: bold;
        font-style: normal;
        font-stretch: normal;
        line-height: 1.64;
        letter-spacing: 0.4px;
        color: #adc7e1;
        text-transform: uppercase;
    }
}
input[type="text"] {
    width: inherit;
    font-family: Roboto;
    font-size: 16px;
    font-weight: normal;
    font-style: normal;
    font-stretch: normal;
    line-height: 2.5;
    letter-spacing: 0.4px;
    text-align: left;
    color: #ffffff;
    border-radius: 4px;
    background-color: rgba(113, 141, 168, 0);
    border: solid 1px #3d536b;
    padding-left: 12px;
    box-sizing: border-box;
}
.save-button {
    background-color: #324258;
    font-family: Arimo;
    font-size: 11px;
    font-weight: bold;
    font-style: normal;
    font-stretch: normal;
    line-height: 3.64;
    letter-spacing: 0.4px;
    text-transform: uppercase;
    color: #adc7e1;
    cursor: pointer;
    border-radius: 4px;
    padding: 0 24px;
    margin-top: 16px;
    min-width: 120px;
    box-sizing: border-box;
    text-align: center;
}

.save-button:hover {
    background-color: #0fd7b7;
    color: #293546;
}
</style>
